import { Dispatch, SetStateAction } from 'react';

import { ConfirmationDialog } from 'components';
import { useTranslation } from 'libs/i18n';

import { FormContent, FormFooter } from '../components';
import { Form, FormFM1FormType, getSchema } from '../forms/formFM1Form';

interface Props {
  onSubmit: (values: FormFM1FormType) => Promise<void>;
  onDownloadFile: () => void;
  setIsError: Dispatch<SetStateAction<boolean>>;
  isSuccessGenerate: boolean;
  errorMessage: string | undefined;
  isError: boolean;
  initialValues: Partial<FormFM1FormType>;
  submitLoading: boolean;
  onBack: () => void;
}

export const FormFM1View = ({
  isSuccessGenerate,
  errorMessage,
  isError,
  submitLoading,
  initialValues,
  setIsError,
  onSubmit,
  onBack,
  onDownloadFile,
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema();

  return (
    <div>
      <Form
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={onSubmit}
      >
        <FormContent />
        <FormFooter submitLoading={submitLoading} />

        {/* Download dialog */}
        <ConfirmationDialog
          fullWidth
          headerCentered
          backButtonLabel={t('formFM1.successDialog.closeTitle')}
          confirmButtonLabel={t('formFM1.successDialog.submitTitle')}
          isOpen={isSuccessGenerate}
          maxWidth="sm"
          subtitle={t('formFM1.successDialog.subtitle')}
          title={t('formFM1.successDialog.title')}
          onBack={onBack}
          onConfirm={onDownloadFile}
        />

        {/* Error dialog */}
        <ConfirmationDialog
          fullWidth
          headerCentered
          hideBackButton
          confirmButtonLabel={t('formFM1.errorDialog.closeTitle')}
          isOpen={errorMessage !== undefined && isError}
          maxWidth="sm"
          subtitle={errorMessage}
          title={t('formFM1.errorDialog.title')}
          onConfirm={() => setIsError(false)}
        />
      </Form>
    </div>
  );
};
